<div class="flex-col flex">
    <div class="end-center flex-row flex">
        @if (projectReleaseStagePermissions.canRequestImages()) {
            <button
                mat-raised-button
                class="cb-margin-bottom-2x cb-margin-top-2x cb-margin-right-2x"
                color="primary"
                (cbClick)="requestImagesDialog()"
                [disabled]="lots?.length < 1"
            >
                Request Images
            </button>
        }
    </div>
    <cb-table *cbWaitFor="mappedItem" class="cb-margin-top cb-margin-bottom-3x" [loaded]="loaded">
        <thead cbTableHead>
            <tr>
                <td>Lot #</td>
                <td>Job #</td>
                <td>Build Link</td>
                <td>Scheme Status</td>
                <td>Applied Concept</td>
                <td>Image Status</td>
                <td>Floor Area</td>
                <td>Bed</td>
                <td>Bath</td>
                <td>Living</td>
                <td>Garage</td>
                <td></td>
            </tr>
        </thead>
        <tbody cbTableBody>
            @for (lot of lots | cbSortByPipe: 'lotNumber' : 'asc'; track lot) {
                <tr>
                    <cb-td-text [value]="lot.lotNumber"></cb-td-text>
                    <cb-td-text [value]="lot.jobNumber"></cb-td-text>
                    <cb-td-text [value]="lot.lotBuildTypeLink"></cb-td-text>
                    <td>
                        @if (!lot.designSchemeStatusId) {
                            <cb-td-text value="Any"></cb-td-text>
                        }
                        @if (lot.designSchemeStatusId) {
                            <cb-td-enum
                                [value]="lot.designSchemeStatusId"
                                [enum]="DESIGN_SCHEME_STATUS_ENUM"
                            >
                            </cb-td-enum>
                        }
                    </td>
                    <cb-td-text [value]="lot.appliedConceptName"></cb-td-text>
                    <td>
                        @if (lot.hasAppliedConceptSingleImage) {
                            <mat-icon class="cb-grey">photo</mat-icon>
                        }
                        @if (lot.hasAppliedConceptBothImages) {
                            <mat-icon class="cb-grey">collections</mat-icon>
                        }
                    </td>
                    <cb-td-text [value]="lot.amenities.floorArea"></cb-td-text>
                    <td style="white-space: nowrap">
                        @if (!isBlockLotType(lot.lotType)) {
                            <mat-icon class="cb-grey">hotel</mat-icon>
                        }
                        &nbsp;{{ getAmenitiesDisplay(lot.amenities.noBedrooms, lot.lotType) }}
                    </td>
                    <td style="white-space: nowrap">
                        @if (!isBlockLotType(lot.lotType)) {
                            <mat-icon class="cb-grey">wc</mat-icon>
                        }
                        &nbsp;{{ getAmenitiesDisplay(lot.amenities.noBathrooms, lot.lotType) }}
                    </td>
                    <td style="white-space: nowrap">
                        @if (!isBlockLotType(lot.lotType)) {
                            <mat-icon class="cb-grey">weekend</mat-icon>
                        }
                        &nbsp;{{ getAmenitiesDisplay(lot.amenities.noLivingRooms, lot.lotType) }}
                    </td>
                    <td style="white-space: nowrap">
                        @if (!isBlockLotType(lot.lotType)) {
                            <mat-icon class="cb-grey">directions_car</mat-icon>
                        }
                        &nbsp;{{ getAmenitiesDisplay(lot.amenities.noGarages, lot.lotType) }}
                    </td>
                    <td cbTableStickyCol="end" cbTableShrinkCol>
                        <button [matMenuTriggerFor]="menu" mat-icon-button>
                            <mat-icon class="cb-grey">more_horiz</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            @if (lotPermissions.canView()) {
                                <button mat-menu-item (cbClick)="viewLot(lot)">
                                    <mat-icon class="cb-grey">pageview</mat-icon>
                                    &nbsp; View Lot
                                </button>
                            }
                            @if (lotPermissions.canEdit()) {
                                <button
                                    mat-menu-item
                                    [disabled]="!canEditLot(lot) || lot.hasClientSale"
                                    (cbClick)="editLot(lot)"
                                >
                                    <mat-icon class="cb-grey">mode_edit</mat-icon>
                                    &nbsp; Edit Lot
                                </button>
                            }
                            @if (lotPermissions.canView()) {
                                <button mat-menu-item (cbClick)="viewLotDetails(lot)">
                                    <mat-icon class="cb-grey">mode_edit</mat-icon>
                                    &nbsp;View Lot Details
                                </button>
                            }
                            @if (lotPermissions.canApplyLotSpec()) {
                                <button
                                    mat-menu-item
                                    [disabled]="!canSelectSpecTemplate(lot)"
                                    (cbClick)="applyTemplate(lot)"
                                >
                                    <mat-icon class="cb-grey">library_books</mat-icon>
                                    &nbsp;Select Spec Template
                                </button>
                            }
                            @if (projectReleaseStagePermissions.canRequestImages()) {
                                <button
                                    mat-menu-item
                                    [disabled]="!canRequestRender(lot)"
                                    (cbClick)="requestRender(lot)"
                                >
                                    <mat-icon class="cb-grey">library_books</mat-icon>
                                    &nbsp;Request Render
                                </button>
                            }
                            @if (projectReleaseStagePermissions.canRequestImages()) {
                                <button
                                    mat-menu-item
                                    [disabled]="!canRequestFloorPlan(lot)"
                                    (cbClick)="requestFloorPlan(lot)"
                                >
                                    <mat-icon class="cb-grey">library_books</mat-icon>
                                    &nbsp;Request Floorplan
                                </button>
                            }
                            @if (
                                projectReleaseStagePermissions
                                    .getLotPermissions()
                                    .canSwitchReleaseStage() || true
                            ) {
                                <button
                                    mat-menu-item
                                    [disabled]="!canSwitchReleaseStage(lot)"
                                    (cbClick)="switchReleaseStage(lot)"
                                >
                                    <mat-icon class="cb-grey">library_books</mat-icon>
                                    &nbsp;Switch Release Stage
                                </button>
                            }
                        </mat-menu>
                    </td>
                </tr>
            }
            @if (lots?.length < 1 && loaded) {
                <tr>
                    <td colspan="17">
                        <mat-icon class="cb-accent">info</mat-icon>
                        &nbsp;No Lots have been added to this Release Stage
                    </td>
                </tr>
            }
        </tbody>
    </cb-table>
</div>
